export default __webpack_public_path__ + "static/media/stream.ca2afd0c.svg";